function matchHeight(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  // Reset heights
  elements.forEach(el => {
    el.style.height = 'auto';
  });

  // Find max height
  elements.forEach(el => {
    const height = el.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Apply max height
  elements.forEach(el => {
    el.style.height = maxHeight + 'px';
  });
}

// Run on load
window.addEventListener('load', () => {
  matchHeight('.sec-our-brands__slide .card__heading');
  matchHeight('.new-layout-content .rich-text__blocks .rich-text__buttons .heading_button_block h3');
  matchHeight('.page-multicolumn .multicolumn-section .multicolumn-card__info h3');
});

// Re-run on resize
window.addEventListener('resize', () => {
  matchHeight('.sec-our-brands__slide .card__heading');
  matchHeight('.new-layout-content .rich-text__blocks .rich-text__buttons .heading_button_block h3');
  matchHeight('.page-multicolumn .multicolumn-section .multicolumn-card__info h3');
});


window.initProductRecommendationsSwiper = function(container, options = {}) {
    const swiperContainer = container || document.querySelector('.product-recommendations-slider');
    
    if (!swiperContainer) {
      console.warn('Swiper container not found');
      return null;
    }

    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not loaded');
      return null;
    }

    // Default options
    const defaultOptions = {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      watchOverflow: false,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        749: { 
          slidesPerView: 2,
          spaceBetween: 15 
        },
        1199: { 
          slidesPerView: 3,
          spaceBetween: 30 
        }
      }
    };

    // Merge custom options with defaults
    const swiperOptions = { ...defaultOptions, ...options };

    // Initialize Swiper
    const swiperInstance = new Swiper(swiperContainer, swiperOptions);
    
    return swiperInstance;
};

// Add class when mobile menu drawer opens
const menuDrawer = document.querySelector('.header--menu-drawer');

if (menuDrawer) {
  menuDrawer.addEventListener('click', function () {
    document.body.classList.toggle('menu-drawer-open');
  });
}